import { render, staticRenderFns } from "./ReportingTrendManage.vue?vue&type=template&id=fa122a70&scoped=true"
import script from "./ReportingTrendManage.vue?vue&type=script&lang=js"
export * from "./ReportingTrendManage.vue?vue&type=script&lang=js"
import style0 from "./ReportingTrendManage.vue?vue&type=style&index=0&id=fa122a70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa122a70",
  null
  
)

export default component.exports